import { useEffect, useState } from "react";
import "./App.css";
import Router from "./Router";
import { useDispatch } from "react-redux";
import { setAccessToken } from "./services/redux/reducers/accessTokenSlice";
import { setIdToken } from "./services/redux/reducers/idTokenSlice";
import { refreshAccessToken } from "./services/auth/auth";

function App() {
  const [auth, setAuth] = useState(localStorage.getItem("accessToken"));
  const [id, setId] = useState(localStorage.getItem("idToken"));
  const dispatch = useDispatch();
  dispatch(setAccessToken(auth));
  dispatch(setIdToken(id));
  useEffect(() => {
    const checkTokenExpiration = async () => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        const tokenExpiration =
          JSON.parse(atob(token.split(".")[1])).exp * 1000;
        const logoutTime = tokenExpiration;
        if (Date.now() >= logoutTime - 5 * 60 * 1000) {
          console.log("Access token is about to expire, refreshing...");
          try {
            const result = await refreshAccessToken();
            const newAccessToken = result.AccessToken;
            const newIdToken = result.IdToken;

            localStorage.setItem("accessToken", newAccessToken);
            localStorage.setItem("idToken", newIdToken);

            setAuth(newAccessToken);
            setId(newIdToken);

            dispatch(setAccessToken(newAccessToken));
            dispatch(setIdToken(newIdToken));
          } catch (error) {
            console.error("Refresh failed, logging out:", error);
            localStorage.clear();
            setAuth(null);
            setId(null);
            dispatch(setAccessToken(null));
            dispatch(setIdToken(null));
          }
        }
      }
    };
    checkTokenExpiration();
    const interval = setInterval(checkTokenExpiration, 60000);
    return () => clearInterval(interval);
  }, []);
  return <Router />;
}

export default App;
